import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import Dialog from "@/components/Dialog"
import { FormGroup } from "@tencent/spaui"
import { connect } from "react-redux"
import MessageBox from "@/components/MessageBox"
import PhoneInput from "@/components/PhoneInput"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"

class AddBlackListModal extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    number: PropTypes.string,
    displayNumber: PropTypes.string,
    contactId: PropTypes.number,
  }

  constructor(props) {
    super(props)

    this.state = {
      disabled: false,
    }
  }

  render() {
    const { disabled, phoneNumber, memo, phoneNumberError } = this.state
    const { displayNumber } = this.props

    return (
      <Dialog className="AddBlackListModal" title="添加电话黑名单" {...this.props} style={{ width: 680 }} onSubmit={this.handleSubmit} loading={disabled} disabled={disabled}>
        <form className="form-inline clearfix">
          <FormGroup className="required" helpBlock={phoneNumberError || "黑名单标记号码，请正确填写手机或固话"} status={phoneNumberError && "error"}>
            <label>标记号码：</label>
            {displayNumber ? <PhoneInput value={displayNumber} disabled={true} /> : <PhoneInput value={phoneNumber || ""} onChange={this.handleChangePhone("phoneNumber")} />}
          </FormGroup>
          <FormGroup className="required with-textarea">
            <label>备注信息：</label>
            <textarea rows={3} cols={30} className="spaui-input" maxLength="255" value={memo || ""} onChange={(e) => this.setState({ memo: e.target.value })} />
          </FormGroup>
        </form>
      </Dialog>
    )
  }

  handleChangePhone = (path) => {
    return (e, phone) => {
      this.setState({
        [path]: phone.number,
        [`${path}Error`]: phone.number && phone.error,
      })
    }
  }

  handleSubmit = _.debounce(
    (e) => {
      e.preventDefault()
      const { webApi, number, contactId } = this.props
      const { phoneNumber, memo, phoneNumberError } = this.state

      if ((!phoneNumber || phoneNumber === "") && !number) {
        this.context.error("添加电话黑名单失败", "标记号码必填！")
        return
      }
      // 有错误直接返回错误信息
      if (phoneNumberError) {
        this.context.error("", phoneNumberError)
        return
      }

      // 参数检测
      if (!!phoneNumberError && phoneNumber.indexOf("*") !== -1 && phoneNumber.indexOf("#") !== -1) {
        this.context.error("", "标记号码无效，请按错误提示修改后再提交！")
        return
      }

      if (!memo || memo === "") {
        this.context.error("添加电话黑名单失败", "备注必填！")
        return
      }

      this.setState({ disabled: true })

      webApi
        .addBlackListRecord()
        .dispatchJson(ActionTypes.CONTACT_PHONE_STATUS, {
          data: {
            phoneNumber: number ? number : phoneNumber,
            contactId: contactId,
            memo: memo,
          },
        })
        .then(
          () => {
            this.setState({ disabled: false })
            this.context.success("添加电话黑名单成功")
            this.props.onClose()
            this.props.callback()
          },
          (error) => {
            this.setState({ disabled: false })
            this.context.error("添加电话黑名单失败", error.message)
          }
        )
    },
    500,
    { leading: true, trailing: false }
  )
}

export default withApi(AddBlackListModal)
AddBlackListModal.contextType = MessageBox
